import { useNavigate } from 'react-router-dom';
import { useAllInboxes, DEFAULT_INBOX_ID } from './use-all-inboxes';


export const usePrimaryInbox = () => {
    const navigate = useNavigate();
    const { data: allInboxes, isFetched } = useAllInboxes();

    const primaryInboxId = allInboxes?.find(inbox => !inbox.is_virtual && inbox.is_primary)?.id ?? DEFAULT_INBOX_ID;

    return {
        goToPrimaryInbox() {
            if (isFetched) {
                navigate(`/landlord/inner/inboxes/${primaryInboxId}`);
            }
        },
        goToInboxesList() {
            navigate('/landlord/inner/inboxes');
        },
        primaryInboxId,
        isReady: isFetched,
    };
};
